import React from 'react';

import styled from 'styled-components';

import CMASummaryApartmentTypeRoomComparisonTitle from './CMASummaryApartmentTypeRoomComparisonTitle';
import CMASummaryBorder from './CMASummaryBorder';
import {
  CMA_SUMMARY_APARTMENT_TYPE_DATA_ROW_ROOM_COMPARISON,
  CMA_SUMMARY_APARTMENT_TYPE_GROUP_DATA_ROW_ROOM_COMPARISON,
  CMA_SUMMARY_DATA_ROW_TYPE,
  CMA_SUMMARY_ROOM_COMPARISON_TYPE_FILTER_ROW_FIELDS,
} from './constants';
import { getSubtitleTestId, getUnitNameTestId } from './testIdUtils';

const Title = styled.div`
  font-family: var(--font-bold);
  font-size: 14px;
`;

const TitleMeta = styled.div`
  font-family: var(--font-regular);
  font-size: 12px;
  color: var(--text-primary);
`;

const Subtitle = styled.div`
  font-family: var(--font-regular);
  font-size: 12px;
  color: var(--text-secondary);
`;

const FlexContainer = styled.span`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;

type Props = {
  rowType?: string;
  rowKey: string;
  title?: string | string[];
  titleMeta?: string | string[];
  subtitle?: string | string[];
  dataTestId?: string;
  expandedRowKeys: string[];
  toggleExpanded: (rowKey: string) => void;
};

const CMASummaryTableTitle = ({
  rowType,
  rowKey,
  title,
  titleMeta,
  subtitle,
  dataTestId,
  expandedRowKeys,
  toggleExpanded,
}: Props) => {
  const isArray = Array.isArray(subtitle);
  switch (rowType) {
    case CMA_SUMMARY_APARTMENT_TYPE_DATA_ROW_ROOM_COMPARISON:
      return (
        <>
          <CMASummaryBorder />
          <CMASummaryApartmentTypeRoomComparisonTitle
            title={title as string[]}
            subtitle={subtitle as string[]}
            hiddenFieldTypes={[
              CMA_SUMMARY_ROOM_COMPARISON_TYPE_FILTER_ROW_FIELDS.RATE,
              CMA_SUMMARY_ROOM_COMPARISON_TYPE_FILTER_ROW_FIELDS.MEDICATION,
            ]}
          />
        </>
      );
    case CMA_SUMMARY_APARTMENT_TYPE_GROUP_DATA_ROW_ROOM_COMPARISON:
      return (
        <>
          <CMASummaryBorder backgroundColor={'var(--background-gray-light)'} />
          <CMASummaryApartmentTypeRoomComparisonTitle
            title={title as string[]}
            subtitle={subtitle as string[]}
            hiddenFieldTypes={[CMA_SUMMARY_ROOM_COMPARISON_TYPE_FILTER_ROW_FIELDS.MEDICATION]}
          />
        </>
      );
    case CMA_SUMMARY_DATA_ROW_TYPE.REVIEWS:
      return (
        <>
          <Title data-test-id={dataTestId}>{title}</Title>
          {titleMeta && <TitleMeta>{titleMeta}</TitleMeta>}
          <FlexContainer>
            {subtitle && subtitle?.length > 1 && (
              <img
                onClick={() => toggleExpanded(rowKey)}
                style={{ transform: expandedRowKeys.includes(rowKey) ? '' : 'rotate(-90deg)' }}
                src={'/icons/dropdown-caret-down-gray.svg'}
                alt="caret"
              />
            )}
            <span>
              {isArray &&
                subtitle.map((line: string, index: number) =>
                  index == 0 || expandedRowKeys.includes(rowKey) ? (
                    <span key={index + line}>
                      <Subtitle data-test-id={`${dataTestId}-${line.toLowerCase()}`}>{line}</Subtitle>
                    </span>
                  ) : null
                )}
              {!isArray && subtitle && <Subtitle>{subtitle}</Subtitle>}
            </span>
          </FlexContainer>
        </>
      );
    default:
      return (
        <>
          <Title data-test-id={dataTestId}>{title}</Title>
          {titleMeta && <TitleMeta data-test-id={getUnitNameTestId(dataTestId)}>{titleMeta}</TitleMeta>}
          {subtitle && <Subtitle data-test-id={getSubtitleTestId(dataTestId)}>{subtitle}</Subtitle>}
        </>
      );
  }
};

export default CMASummaryTableTitle;
